import { InputBase, styled } from "@mui/material";

const CustomTrelloInput = styled(InputBase)(({ checked }) => ({
  flexGrow: 1,
  marginLeft: 8,
  fontSize: "1rem",
  fontWeight: 500,
  textDecoration: checked ? "line-through" : "none",
  color: checked ? "#888" : "inherit",
  width: "100%",
  overflow: "hidden",
  "& .MuiInputBase-input": {
    padding: "4px 0",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minHeight: "auto",
  },
  "& .MuiInputBase-input:focus": {
    borderBottom: "1px solid black",
    backgroundColor: "lightgray",
    padding: "4px",
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "unset",
  },
}));

export default CustomTrelloInput;
